import { DataSourcePropertyValueChange } from "../../../Data/DataSourcePropertyValueChange";
import { IJNativeEvent } from "../../../JNative";
import { PropertyChange } from "../../../PropertyChange";
import { Property } from "../../../RadObject";
import { BuiltInTypes } from "../../../Server/DotNet/System/BuiltInTypes";
import { IControl } from "../Control";
import { NAMESPACE } from "./_Namespace";

export type PropertyBoundControlMixinPropertyValues = {
    dataSourceProperty: string;
    dataSourcePropertyType: BuiltInTypes;
    value: any;
};

export type PropertyBoundControlMixinProperties = {
    [name in keyof PropertyBoundControlMixinPropertyValues]: Property<PropertyBoundControlMixinPropertyValues[name]>
};

export interface IPropertyBoundControlMixin extends IControl, PropertyBoundControlMixinProperties
{
    __processDataSourcePropertyValueChanged?: boolean;

    _dataSourcePropertyChanged(change: PropertyChange<string>): void;
    _dataSourcePropertyTypeChanged(change: PropertyChange<string>): void;
    _getDataSourceValue(): any;
    _refreshFromDataSource(): void;
    _setDataSourceValue(value: any, inhibitEvent?: boolean): void;
    _valueChanged(change: PropertyChange<any>): void;

    onDataSourcePropertyValueChanged(evt: IJNativeEvent, change: DataSourcePropertyValueChange<any>): void;
}

export class PropertyBoundControlMixin
{
    public static classNamespace = NAMESPACE + "PropertyBoundControlMixin";
    public static className = "PropertyBoundControlMixin";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static construct(control: IPropertyBoundControlMixin)
    {
        control.__processDataSourcePropertyValueChanged = true;
        control.addCssClass("rad-control-property-bound-control");
    }

    public static _dataSourcePropertyChanged(control: IPropertyBoundControlMixin, change: PropertyChange<string>): void
    {
        control.refreshFromDataSource();
    }
    public static _dataSourcePropertyTypeChanged(control: IPropertyBoundControlMixin, change: PropertyChange<string>): void
    {
        control.refreshFromDataSource();
    }
    public static _getDataSourceValue(control: IPropertyBoundControlMixin): any
    {
        const
            dataSource = control.dataSource.get(),
            dataSourceProperty = control.dataSourceProperty.get();

        if (!dataSource || !dataSourceProperty)
            return;

        return dataSource.propertyValueByPathGet(dataSourceProperty);
    }
    public static _refreshFromDataSource(control: IPropertyBoundControlMixin): void
    {
        if (!control.dataSource.get() || !control.dataSourceProperty.get())
            return;

        let
            value = control._getDataSourceValue();

        if (value === undefined)
        {
            value = null;
            control._setDataSourceValue(value, true);
        }

        control.value.set(value);
    }
    public static _setDataSourceValue(control: IPropertyBoundControlMixin, value: any, inhibitEvent?: boolean): void
    {
        const
            dataSource = control.dataSource.get(),
            dataSourceProperty = control.dataSourceProperty.get();

        if (!dataSource || !dataSourceProperty)
            return;

        dataSource.propertyValueByPathSet(dataSourceProperty, value, inhibitEvent);
    }
    public static _valueChanged(control: IPropertyBoundControlMixin, change: PropertyChange<any>): void
    {
        control.triggerHandler("valueChanged", change);
    }

    public static onDataSourcePropertyValueChanged(control: IPropertyBoundControlMixin, evt: IJNativeEvent, change: DataSourcePropertyValueChange<any>): void
    {
        if (!control.__processDataSourcePropertyValueChanged)
            return;

        const
            dataSourceProperty = control.dataSourceProperty.get();

        if (!dataSourceProperty)
            return;

        if (!(dataSourceProperty + ".").startsWith(change.path + "."))
            return;

        control.refreshFromDataSource();
    }
}